
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi et comment utiliser Google Ads pour votre entreprise",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apprenez comment Google Ads peut booster votre visibilité en ligne et attirer plus de clients. Suivez notre guide pour créer des campagnes performantes.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Pourquoi utiliser Google Ads et comment ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous présente Google Ads et vous explique comment utiliser cet outil pour améliorer votre visibilité sur Internet.",
        },
      ],
    };
  },
};
